import { useSuspenseQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { useNotificationQueryOptions } from "@/queries/notification-queries";
import { taskListRoute } from "@/routes/taskListRoute";
import { TaskListBadgeColorShape } from "../TaskListBadge";
import { UserAvatar } from "../UserAvatar";
import { Button } from "../ui/button";
import { Separator } from "../ui/separator";

export default function TaskListInviteNotification({ notificationId }: { notificationId: number }) {
    const { data: notification } = useSuspenseQuery(useNotificationQueryOptions({ id: notificationId }));

    if (!notification.taskList) {
        throw new Error("Task list not found for this notification.");
    }

    return (
        <div className="p-4 flex flex-col gap-4">
            <div className="flex items-center gap-2">
                <UserAvatar user={notification.otherUser} size="md" />
                <div>
                    <div className="font-medium">{notification.otherUser.name}</div>
                    <div className="text-sm text-zinc-600">{notification.otherUser.email}</div>
                </div>
            </div>
            <Separator />
            <div className="flex flex-col gap-2 items-start">
                <p>Hi there,</p>
                <p>
                    <span className="font-medium">{notification.otherUser.name}</span> has invited you to collaborate on the{" "}
                    <span className="font-medium">{notification.taskList?.name}</span> task list .
                </p>
                <Button
                    variant="outline"
                    nativeButton={false}
                    render={
                        <Link to={taskListRoute.to} params={{ taskListId: notification.taskList.id }}>
                            <TaskListBadgeColorShape color={notification.taskList?.color} />
                            Open list
                        </Link>
                    }
                ></Button>
            </div>
        </div>
    );
}
